import { api } from 'roadie-ui'
import { Coords, GetTimezoneApiResponse } from 'types/timezone'

export async function getTimezone(coords: Coords, forTimePeriod = new Date()): Promise<GetTimezoneApiResponse> {
  const { longitude, latitude } = coords
  try {
    const apiResponse = await api.get(
      `fetch_timezone?latitude=${latitude}&longitude=${longitude}&timestamp=${new Date(forTimePeriod).getTime() / 1000}`
    )

    return apiResponse.data
  } catch {
    return {
      timeZoneName: new Date().toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop() || '',
      timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
      dstTime: 0,
      rawOffset: 0,
      status: '',
    }
  }
}
